import { render, staticRenderFns } from "./MemberCallerComponent.vue?vue&type=template&id=8d80a9e6&scoped=true&"
import script from "./MemberCallerComponent.vue?vue&type=script&lang=js&"
export * from "./MemberCallerComponent.vue?vue&type=script&lang=js&"
import style0 from "./MemberCallerComponent.vue?vue&type=style&index=0&id=8d80a9e6&prod&scoped=true&lang=css&"
import style1 from "./MemberCallerComponent.vue?vue&type=style&index=1&id=8d80a9e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d80a9e6",
  null
  
)

export default component.exports